import api from '..';
import useResourceList from './useResourceList';
import useQuery from './useQuery';

export const useDocumentsList = (queryVariables = {}, queryConfig = {}) => {
  const queryResult = useResourceList({ name: 'documents', api: api.documents }, queryVariables, queryConfig);

  return {
    documents: queryResult.resolvedData,
    latestDocuments: queryResult.latestData,
    ...queryResult,
  };
};

export const useDocumentsByIds = (ids, queryConfig = {}) => {
  const queryResult = useQuery(['documents', { ids }], api.documents.getByIds, {
    ...queryConfig,
    enabled: ids?.length > 0,
  });

  return {
    documents: queryResult.data || [],
    ...queryResult,
  };
};
